define("settings/components/downgrade-slide-groups", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="tDG--slide" data-test-id="group-slide">
    <header class="o--modalHeader tDG--slideHeader">
      <p class="o--modalHeader__title">
        {{t "account.downgrade.groups.merge_groups" count=@groupCount}}
      </p>
      <p class="u--m__tb__xs">
        {{t "account.downgrade.groups.all_will_be_merged" name=@firstGroup.name}}
      </p>
    </header>
  
    <div class="o--modalBody tDG--scroll__body tDG--scroll__body--lg">
      <Downgrade::MergeGroups
        @account={{@account}}
        @firstGroup={{@firstGroup}}
        @hasMergedGroups={{@hasMergedGroups}}
        @mergeAllGroups={{@mergeAllGroups}}
        @otherGroups={{@otherGroups}}
        @unloadDeletedGroups={{@unloadDeletedGroups}}
      />
    </div>
  </div>
  */
  {
    "id": "48/l8i5o",
    "block": "[[[10,0],[14,0,\"tDG--slide\"],[14,\"data-test-id\",\"group-slide\"],[12],[1,\"\\n  \"],[10,\"header\"],[14,0,\"o--modalHeader tDG--slideHeader\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.groups.merge_groups\"],[[\"count\"],[[30,1]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--m__tb__xs\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.downgrade.groups.all_will_be_merged\"],[[\"name\"],[[30,2,[\"name\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"o--modalBody tDG--scroll__body tDG--scroll__body--lg\"],[12],[1,\"\\n    \"],[8,[39,1],null,[[\"@account\",\"@firstGroup\",\"@hasMergedGroups\",\"@mergeAllGroups\",\"@otherGroups\",\"@unloadDeletedGroups\"],[[30,3],[30,2],[30,4],[30,5],[30,6],[30,7]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@groupCount\",\"@firstGroup\",\"@account\",\"@hasMergedGroups\",\"@mergeAllGroups\",\"@otherGroups\",\"@unloadDeletedGroups\"],false,[\"t\",\"downgrade/merge-groups\"]]",
    "moduleName": "settings/components/downgrade-slide-groups.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});